<template>
    <v-content>
        <v-row class="pb-0 pb-sm-2">
            <v-col class="display-1">
                Шаблоны голосовых рассылок
            </v-col>
            <v-col>
                <div class="float-right">
                    <v-btn color="primary" depressed @click="createTemplate()">
                        <v-icon small>mdi-plus</v-icon>
                        Создать шаблон голосовой рассылки
                    </v-btn>
                    <v-btn color="info" style="margin-left: 5px" depressed @click="updateTemplatesList()">
                        Обновить список шаблонов
                    </v-btn>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="4">
                <v-text-field
                    v-model="name"
                    @input="getCallTemplates"
                    placeholder="Название"
                    outlined
                    hide-details
                    clearable
                    dense
                ></v-text-field>
            </v-col>
            <v-col cols="4">
                <v-select
                  outlined
                  dense
                  hide-details
                  clearable
                  :items="mailing_accounts"
                  item-value="id"
                  item-text="name"
                  label="Аккаунт рассыльщика"
                  v-model="mailing_account_id"
                  @input="getCallTemplates"
                />
            </v-col>
        </v-row>
        <b-table
            :data="templates.results"
            :loading="isLoading"
            paginated
            backend-pagination
            :total="templates.total"
            :per-page="perPage.value"
            @page-change="onPageChange"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
            backend-sorting
            :default-sort="[sortField, sortOrder]"
            @sort="onSort"
        >
            <template slot-scope="props">
                <b-table-column field="id" label="ID" centered numeric sortable>
                    {{ props.row.id }}
                </b-table-column>

                <b-table-column field="name" label="Название" centered sortable>
                    {{ props.row.name }}
                </b-table-column>

                <b-table-column field="status" label="Статус" centered>
                    {{ props.row.status }}
                </b-table-column>

                <b-table-column field="type" label="Тип" centered>
                    {{ types.find(element => element.value == props.row.type).name ? types.find(element => element.value == props.row.type) && props.row.type : 'Не известно'}}
                </b-table-column>

                <b-table-column field="created_at" label="Создано" centered sortable>
                    {{ props.row.created_at | isoToDateTime}}
                </b-table-column>

                <b-table-column
                      label="Действия"
                      style="width: 20px;"
                      centered
                  >
                  <b-tooltip
                      v-if="props.row.type !== 'zvonobot'"
                      label="Изменить">
                      <div
                          @click="editTemplate(props.row.id)">
                          <b-icon
                              icon="pencil"
                          ></b-icon>
                      </div>
                  </b-tooltip>
                  <b-tooltip
                      label="Удалить">
                      <div
                          @click="removeTemplate(props.row.id)">
                          <b-icon
                              icon="delete"
                          ></b-icon>
                      </div>
                  </b-tooltip>
                </b-table-column>
            </template>
              <template slot="bottom-left">
                <div class="pagination-controls">
                  <v-select
                    style="width: fit-content; float: left;"
                    v-model="perPage.value"
                    @change="getCallTemplates"
                    :items="perPageOptions"
                    item-text="name"
                    item-value="value"
                    outlined
                    hide-details
                    dense
                  />
                </div>
            </template>
        </b-table>
    </v-content>
</template>

<script>
export default {
    name: 'callTemplates',
    data() {
        return {
            name: "",
            sortField: "id",
            sortOrder: "desc",
            page: 1,
            perPage: {
                value: 20,
            },
            perPageOptions: [
                { name: "10 на странице", value: 10 },
                { name: "20 на странице", value: 20 },
                { name: "50 на странице", value: 50 },
                { name: "100 на странице", value: 100 },
            ],
            type: {
                value: null,
            },
            types: [
                { name: "Из админки звонобота", value: 'zvonobot' },
                { name: "Из этой админки", value: 'system' },
            ],
            mailing_account_id: null,
        }
    },
    created() {
        this.getCallTemplates();
        this.$store.dispatch('GET_MAILING_ACCOUNT_LIST', { type_of_notification: 'call' });
    },
    computed: {
        templates() {
            return this.$store.getters.TEMPLATES;
        },
        isLoading() {
            return this.$store.getters.TEMPLATES_IS_LOADING;
        },
        mailing_accounts() {
            return this.$store.getters.MAILING_ACCOUNTS_LIST.results;
        },
    },
    methods: {
        createTemplate() {
            const route = this.$router.resolve({ path: '/call-templates/create/' });
            this.$router.push({ path: route.href });
        },
        editTemplate(template_id) {
            const route = this.$router.resolve({ path: `/call-templates/update/${template_id}` });
            this.$router.push({ path: route.href });
        },
        removeTemplate(template_id) {
            this.$store.dispatch('DELETE_TEMPLATE', template_id)
                .then(() => {
                    this.$toaster.success('Шаблон удален');
                    this.getCallTemplates();
                })
                .catch(() => {
                    this.$toaster.error('Неизвестная ошибка!');
                });
        },
        getCallTemplates() {
            const params = {
                sort_by: this.sortField,
                order: this.sortOrder,
                page: this.page,
                perPage: this.perPage.value,
                name: this.name,
                mailing_account: this.mailing_account_id,
            };
            this.$store.dispatch('GET_TEMPLATES', params);
        },
        onSort(field, order) {
            this.sortField = field;
            this.sortOrder = order;
            this.getCallTemplates();
        },
        onPageChange(page) {
            this.page = page;
            this.getCallTemplates();
        },
        updateTemplatesList() {
            this.$store
                .dispatch("UPDATE_CALL_TEMPLATES")
                .then(() => {
                    this.getCallTemplates();
                    this.$toast.success("Аудиоролики обновлены!");
                })
                .catch(() => {
                    this.$toast.error("Неизвестная ошибка!");
                });
        },
    }
}
</script>

<style>

</style>
